export default class FormError {
    public field: string = "";
    public errors: string[];

    constructor(field: string, errors: string[]){
        this.field = field;
        this.errors = errors;
    }
}